module.exports = __webpack_public_path__ + "static/media/expander.3cfabad4.svg";